import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import type {ICustomForm} from '../types';
import {parseCustomFormDataJson} from '../utils';

/**
 * `getAttributeTemplatesForCategoryContext` request params
 * (what is used to send to server)
 */
export type GetCustomFormByNameRequestOptions = {
	name: string;
};

/**
 * `getCustomFormByName` request
 * (what gets sent to the server)
 */
export type GetCustomFormByNameRequest = [
	GetCustomFormByNameRequestOptions['name'],
];

/**
 * `getCustomFormByName` response
 * (what comes back from the server)
 */
export type GetCustomFormByNameResponse = SuccessResponse<
	(Omit<ICustomForm, 'formData'> & {formData: string}) | null
>;

/**
 * `getCustomFormByName` result
 * (what is utilized from the server response)
 */
export type GetCustomFormByNameResult = ICustomForm | null;

export const getCustomFormByNameEndpoint = 'getCustomFormByName';

/**
 * Import asset
 */
export const getCustomFormByName = async (
	{name}: GetCustomFormByNameRequestOptions,
	signal?: AbortSignal,
): Promise<ICustomForm | null> => {
	const client = NetxQueryClient();

	const requestParams: GetCustomFormByNameRequest = [name];

	return client
		.post<GetCustomFormByNameResponse>(
			getCustomFormByNameEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => {
			if (!response.data.result) return null;
			const {formData, ...rest} = response.data.result;
			return {
				...rest,
				formData: parseCustomFormDataJson(formData),
			};
		});
};

export default getCustomFormByName;
